//import "./css/ListaEmpleados.css"; // <-- custom styles
import { useContext, useState, useRef, useEffect } from "react";

import { Card, Row, Col, Container, Button } from "react-bootstrap";

import { Titulo, Cargando, excepcionVacia, llamarApi, logger } from "./Comun";

import Contexto from "./Contexto";

const ListaEmpleados = (props) => {
  const parametros = useContext(Contexto);

  const [isLoading, setIsLoading] = useState(true);

  const [resListaEmpleados, setResListaEmpleados] = useState(null);
  const [idEmpleadoHover, setIdEmpleadoHover] = useState(false);

  const fetchEjecutado = useRef(false);

  const handleChangeIdEmpleado = (pIdEmpleado) => {
    if (pIdEmpleado !== null) {
      props.setIdEmpleado(pIdEmpleado);
      props.irAPAso("LTS");
    }
  };

  const handleMouseEnter = (e) => {
    setIdEmpleadoHover(e);
  };

  const handleMouseLeave = (e) => {
    setIdEmpleadoHover(null);
  };

  const handleClickOtraSede = () => {
    props.setIdSede(null);
    props.irAPAso("LS");
  };
/*
  const getNumeroEmpleadosPorFila = (numeroEmpleadosMostrar, maxCols) => {
    if (numeroEmpleadosMostrar <= 1) return 12;
    if (numeroEmpleadosMostrar === 2) return 12 / 2;
    if (numeroEmpleadosMostrar === 3) return 12 / 3;
    if (numeroEmpleadosMostrar === 3) return 12 / 4;
    return maxCols; // límite máximo de columnas por breakpoint
  };
*/
  useEffect(() => {
    if (fetchEjecutado.current) return;
    fetchEjecutado.current = true;

    const urlAPI = parametros.urlBaseApis + "ss_api_lista_empleados.php";

    logger(
      new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        "." +
        new Date().getSeconds() +
        "- Llamo a la api de lista de empleados"
    );

    llamarApi({
      url: urlAPI,
      jwt: props.jwt,
      method: "GET",
      payload: { idSede: props.idSede },
      onSuccess: (data) => {
        props.setJwt(data.jwt);
        setResListaEmpleados(data.arrayEmpleados);
        props.setExcepcion(excepcionVacia);
      },
      onError: (err) => props.setExcepcion(err),
      onFinally: () => setIsLoading(false),
    });
  }, [props.idSede]);

  const numeroEmpleados = resListaEmpleados?.length ?? 0;

  if (isLoading)
    return <Cargando mensaje="Cargando especialistas ..."></Cargando>;

  return (
    <>
      <Titulo textoTitulo="Selecciona el especialista con el que quieres solicitar tu cita"></Titulo>
      <Container
        fluid
        className="flex-grow-1 d-flex flex-column justify-content-center pb-4 px-3"
      >
        <Row className="justify-content-center">
          {resListaEmpleados.map((empleado, index) => (
            <Col
              className="mb-4"
			  xs={6}
			  sm={6}
			  md={4}
			  lg={3}
			  xl={2}
			  /*
              xs={getNumeroEmpleadosPorFila(numeroEmpleados, 6)}
              sm={getNumeroEmpleadosPorFila(numeroEmpleados, 6)}
              md={getNumeroEmpleadosPorFila(numeroEmpleados, 4)}
              lg={getNumeroEmpleadosPorFila(numeroEmpleados, 2)}*/
              // xs={6} sm={6} md={4} lg={2}
              key={`em-${index}`}
            >
              <Card
                className="h-100 shadow-sm overflow-hidden card-resaltada"
                id={empleado.idEmpleado}
                key={empleado.idEmpleado}
                onClick={() => handleChangeIdEmpleado(empleado.idEmpleado)}
                style={{ cursor: "pointer" }}
                onMouseEnter={() => handleMouseEnter(empleado.idEmpleado)}
                onMouseLeave={() => handleMouseLeave(empleado.idEmpleado)}
                border={
                  idEmpleadoHover === empleado.idEmpleado ? "primary" : ""
                }
              >
                {" "}
                {empleado.urlFotoSolicitudesSesiones ? (
                  <Card.Img
                    variant="top"
                    className="p-2 card-img-foto-especialista"
                    src={empleado.urlFotoSolicitudesSesiones}
                  />
                ) : (
                  <div className="p-2 card-sin-foto-especialista"></div>
                )}
                <Card.Body>
                  <Card.Title className="text-center">
                    {empleado.nombre} {empleado.apellido1}
                  </Card.Title>
                  {empleado.descripcionPerfil && (
                    <>
                      <hr></hr>
                      <Row className="align-items-start g-1 text-muted">
                        <Col xs="auto">
                          <i className="bi bi-person-lines-fill me-2 text-secondary pe-1"></i>
                        </Col>
                        <Col>{empleado.descripcionPerfil}</Col>
                      </Row>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <Row className="w-100 justify-content-center text-center">
          <Col xs={12} sm={12} md={12} lg={12}>
            {parametros.permitirEmpleadoSinPreferencia === 1 ? (
              <Button
                className="px-3 mx-2"
                onClick={() =>
                  handleChangeIdEmpleado(parametros.idEmpleadoSinPreferencia)
                }
              >
                No tengo preferencia
              </Button>
            ) : (
              ""
            )}
            {parametros.multiSede === 1 ? (
              <Button className="px-3 mx-2" onClick={handleClickOtraSede}>
                Seleccionar otra clínica
              </Button>
            ) : (
              ""
            )}{" "}
          </Col>{" "}
        </Row>
      </Container>
    </>
  );
};
export default ListaEmpleados;
